import NavBar from '../features/navbar/Navbar';
import UserProfile from '../features/user/components/UserProfile';
import MainLayout from '../components/MainLayout';

function UserProfilePage() {
  return (
    <MainLayout>
      <NavBar>
        <UserProfile></UserProfile>
      </NavBar>
    </MainLayout>
  );
}

export default UserProfilePage;